export interface ComponentRemovalEvents {
    BEFORE_REMOVE: string
    AFTER_REMOVE: string
    AFTER_GHOSTIFY: string
}

export interface ValidationResult {
    success: boolean
    error?: string
}

export const isValidationError = (result: ValidationResult): result is ValidationResult & {error: string} => {
    return !result.success
}
